import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import CrisisAlertIcon from "@mui/icons-material/CrisisAlert";
import DynamicFormIcon from "@mui/icons-material/DynamicForm";
import EditNoteIcon from "@mui/icons-material/EditNote";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import FavoriteIcon from "@mui/icons-material/Favorite";
import HikingIcon from "@mui/icons-material/Hiking";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import LogoutIcon from "@mui/icons-material/Logout";
import PeopleIcon from "@mui/icons-material/People";
import PublicIcon from "@mui/icons-material/Public";
import QuizIcon from "@mui/icons-material/Quiz";
import SettingsIcon from "@mui/icons-material/Settings";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";
import VisibilityIcon from "@mui/icons-material/Visibility";

interface GetIconComponentProps {
  iconName: string;
}

const GetIconComponent: React.FC<GetIconComponentProps> = ({ iconName }) => {
  switch (iconName) {
    case "Favorite":
      return <FavoriteIcon />;
    case "Quiz":
      return <QuizIcon />;
    case "TipsAndUpdates":
      return <TipsAndUpdatesIcon />;
    case "Hiking":
      return <HikingIcon />;
    case "AutoFixHigh":
      return <AutoFixHighIcon />;
    case "Public":
      return <PublicIcon />;
    case "CrisisAlert":
      return <CrisisAlertIcon />;
    case "Settings":
      return <SettingsIcon />;
    case "AdminPanelSettingsIcon":
      return <AdminPanelSettingsIcon />;
    case "EditNote":
      return <EditNoteIcon />;
    case "LogoutIcon":
      return <LogoutIcon />;
    case "PeopleIcon":
      return <PeopleIcon />;
    case "DynamicFormIcon":
      return <DynamicFormIcon />;
    case "HistoryEduIcon":
      return <HistoryEduIcon />;
    case "VisibilityIcon":
      return <VisibilityIcon />;
    case "EventRepeat":
      return <EventRepeatIcon />;
    default:
      return null;
  }
};

export default GetIconComponent;
